import { Card, Divider, Stack } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { Loader, LoadingButton } from "../../../shared";
import { useSocialConfig } from "../hooks";
import { TenantInfoText } from "../components";

export const SocialConfig = () => {
  const { formValidator, state, onChange, onSubmit } = useSocialConfig();
  const { formData } = state;

  const validations = {
    facebook: formValidator.current.message(
      "Facebook URL",
      formData.facebook,
      "url",
    ),
    twitter: formValidator.current.message(
      "Twitter URL",
      formData.twitter,
      "url",
    ),
    instagram: formValidator.current.message(
      "Instagram URL",
      formData.instagram,
      "url",
    ),
    tiktok: formValidator.current.message("TikTok URL", formData.tiktok, "url"),
    youtube: formValidator.current.message(
      "YouTube URL",
      formData.youtube,
      "url",
    ),
  };

  return (
    <Card
      sx={{ p: "24px", gap: "20px", display: "flex", flexDirection: "column" }}
    >
      <TenantInfoText infoKey="socialConfig" alert />

      {state.isLoading ? (
        <Stack height="400.8px" justifyContent="center" alignItems="center">
          <Loader />
        </Stack>
      ) : (
        <>
          <InputControl
            name="facebook"
            label="Facebook"
            placeholder="https://facebook.com/example"
            value={formData.facebook}
            onChange={onChange}
            error={!!validations.facebook}
            helperText={validations.facebook}
          />
          <InputControl
            name="twitter"
            label="Twitter"
            placeholder="https://twitter.com/example"
            value={formData.twitter}
            onChange={onChange}
            error={!!validations.twitter}
            helperText={validations.twitter}
          />
          <InputControl
            name="instagram"
            label="Instagram"
            placeholder="https://instagram.com/example"
            value={formData.instagram}
            onChange={onChange}
            error={!!validations.instagram}
            helperText={validations.instagram}
          />
          <InputControl
            name="tiktok"
            label="TikTok"
            placeholder="https://tiktok.com/@example"
            value={formData.tiktok}
            onChange={onChange}
            error={!!validations.tiktok}
            helperText={validations.tiktok}
          />
          <InputControl
            name="youtube"
            label="YouTube"
            placeholder="https://youtube.com/@example"
            value={formData.youtube}
            onChange={onChange}
            error={!!validations.youtube}
            helperText={validations.youtube}
          />

          <Divider />
          <LoadingButton
            variant="contained"
            sx={{ ml: "auto", width: { xs: "100%", sm: "max-content" } }}
            onClick={onSubmit}
            loading={state.isSubmitting}
            disabled={!state.hasChanges}
          >
            Save
          </LoadingButton>
        </>
      )}
    </Card>
  );
};
